// GET_HOME_SLIDER
export const GET_HOME_DATA_REQUEST = 'GET_HOME_DATA_REQUEST';
export const GET_HOME_DATA_SUCCESS = 'GET_HOME_DATA_SUCCESS';
export const GET_HOME_DATA_FAILURE = 'GET_HOME_DATA_FAILURE';

// TOGGLE_THEME
export const TOGGLE_THEME = 'TOGGLE_THEME';
export const TOGGLE_THEME_SUCCESS = 'TOGGLE_THEME_SUCCESS';
export const TOGGLE_THEME_FAILURE = 'TOGGLE_THEME_FAILURE';

// OPEN_MODAL
export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';

// GET_HOME_SLIDER
export const GET_POST_CATEGRY_REQUEST = 'GET_POST_CATEGRY_REQUEST';
export const GET_POST_CATEGRY_SUCCESS = 'GET_POST_CATEGRY_SUCCESS';
export const GET_POST_CATEGRY_FAILURE = 'GET_POST_CATEGRY_FAILURE';

//Guest ID
export const SET_LANGUAGE_SUCCESS = 'SET_LANGUAGE_SUCCESS';

//Guest ID
export const GUEST_ID = 'GUEST_ID';

// Logout
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

// SIGN_IN
export const SIGN_IN_REQUEST = 'SIGN_IN_REQUEST';
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
export const SIGN_IN_FAILURE = 'SIGN_IN_FAILURE';

// SIGN_UP
export const SIGN_UP_REQUEST = 'SIGN_UP_REQUEST';
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS';
export const SIGN_UP_FAILURE = 'SIGN_UP_FAILURE';

// GET_USER_PROFILE
export const GET_USER_PROFILE_REQUEST = 'GET_USER_PROFILE_REQUEST';
export const GET_USER_PROFILE_SUCCESS = 'GET_USER_PROFILE_SUCCESS';
export const GET_USER_PROFILE_FAILURE = 'GET_USER_PROFILE_FAILURE';

// GET_INTREST
export const GET_INTREST_REQUEST = 'GET_INTREST_REQUEST';
export const GET_INTREST_SUCCESS = 'GET_INTREST_SUCCESS';
export const GET_INTREST_FAILURE = 'GET_INTREST_FAILURE';

// GET_INTREST_PASS
export const GET_INTREST_PASS_REQUEST = 'GET_INTREST_PASS_REQUEST';
export const GET_INTREST_PASS_SUCCESS = 'GET_INTREST_PASS_SUCCESS';
export const GET_INTREST_PASS_FAILURE = 'GET_INTREST_PASS_FAILURE';

// GET_TEG_LIST
export const GET_TEG_LIST_REQUEST = 'GET_TEG_LIST_REQUEST';
export const GET_TEG_LIST_SUCCESS = 'GET_TEG_LIST_SUCCESS';
export const GET_TEG_LIST_FAILURE = 'GET_TEG_LIST_FAILURE';